module.exports = __webpack_public_path__ + "img/ld.3be6e4fc.png";